import { render, staticRenderFns } from "./contactService.vue?vue&type=template&id=061ac542&scoped=true"
import script from "./contactService.vue?vue&type=script&lang=js"
export * from "./contactService.vue?vue&type=script&lang=js"
import style0 from "./contactService.vue?vue&type=style&index=0&id=061ac542&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "061ac542",
  null
  
)

export default component.exports